import { Injectable } from '@angular/core';
import { IDocumentData } from '@app/transactions/components/upload-document/upload-document.component';
import { DocumentCollection, Service } from 'ngx-jsonapi';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Validation } from '../resources/validation';

@Injectable({
    providedIn: 'root'
})
export class ValidationsService extends Service<Validation> {
    public resource: typeof Validation = Validation;
    public type: string = 'validations';

    public constructor() {
        super();
        this.register();
    }

    public getDocument(document_data: IDocumentData, beforepath: string): Observable<DocumentCollection<Validation>> {
        return this.all({
            remotefilter: { 'validation_type.id': document_data.document_type },
            sort: ['-id'],
            beforepath: beforepath
        }).pipe(filter((validations: DocumentCollection<Validation>): boolean => validations.loaded));
    }
}
